export enum ConversationStatus {
  IDLE = 'idle',
  ONGOING = 'ongoing',
  ONGOING_WAITING = 'ongoing_waiting',
  ONGOING_TYPING = 'ongoing_typing',
  FINISHED = 'finished',
}

interface SystemMessage {
  type: 'system'
  author: 'ai'
  data: {
    text: string
  }
}

interface TextMessage {
  type: 'text'
  author: 'user' | 'ai'
  data: {
    text: string
  }
}

interface FieldObtainedMessage {
  type: 'fieldObtained'
  author: 'ai'
  data: {
    field_id: string
    field_value: number | string | boolean
  }
}

export type Message = TextMessage | SystemMessage | FieldObtainedMessage
